import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import styles from '@components/DevToolbar/DevToolbarTab/DevToolbarTabSettings/DevToolbarTabSettings.styles';
import commonStyles from '@components/DevToolbar/DevToolbarTab/common.styles';
import DevToolbarTabHeader from '@components/DevToolbar/DevToolbarTab/DevToolbarTabHeader/DevToolbarTabHeader';
import Button from '@components/Button/Button';
import { TDevToolbarPosition } from '@components/DevToolbar/typescript';
type PropsType = {
  debugMode: boolean;
  setDebugMode: Dispatch<SetStateAction<boolean>>;
  position: TDevToolbarPosition;
  setPosition: Dispatch<SetStateAction<TDevToolbarPosition>>;
  hoverSize: number;
  setHoverSize: Dispatch<SetStateAction<number>>;
};
const DevToolbarTabSettings = ({
  debugMode,
  setDebugMode,
  position,
  setPosition,
  hoverSize,
  setHoverSize
}: PropsType) => <div sx={commonStyles.toolbarTab}>
    <DevToolbarTabHeader name="Settings" />
    <div>
      <div sx={commonStyles.miniHeading}>Debug Mode</div>
      <div sx={styles.section}>
        <Button variant={debugMode ? 'default' : 'outlined'} variantColor="white" size="small" onClick={() => setDebugMode(true)}>
          On
        </Button>
        <Button variant={!debugMode ? 'default' : 'outlined'} variantColor="white" size="small" onClick={() => setDebugMode(false)}>
          Off
        </Button>
      </div>
      <div sx={commonStyles.miniHeading}>Toolbar position</div>
      <div sx={styles.section}>
        <Button variant={position === 'top' ? 'default' : 'outlined'} variantColor="white" size="small" onClick={() => setPosition('top')}>
          Top
        </Button>
        <Button variant={position === 'bottom' ? 'default' : 'outlined'} variantColor="white" size="small" onClick={() => setPosition('bottom')}>
          Bottom
        </Button>
      </div>
      <div sx={commonStyles.miniHeading}>Hover size</div>
      <div sx={styles.section}>
        <input type="number" value={hoverSize} name="hoverSize" onChange={(e: ChangeEvent<HTMLInputElement>) => setHoverSize(e.target.value ? parseInt(e.target.value, 10) : 200)} />
      </div>
    </div>
  </div>;
export default DevToolbarTabSettings;